import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { products as productsApi } from '../utils/api';
import { ProductCard } from './ProductCard';
import { useRecentlyViewed } from '../hooks/useRecentlyViewed';
import { ArrowRight } from 'lucide-react';

export const RecentlyViewed = ({ excludeId = null }) => {
  const { recentIds } = useRecentlyViewed();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const ids = recentIds.filter((id) => id !== excludeId).slice(0, 4);
    if (ids.length === 0) return;

    const loadItems = async () => {
      try {
        const all = await productsApi.getAll();
        const matched = ids.map((id) => all.find((p) => p.id === id)).filter(Boolean);
        setItems(matched);
      } catch { /* ignore */ }
    };
    loadItems();
  }, [recentIds, excludeId]);

  if (items.length === 0) return null;

  return (
    <section className="py-8 md:py-10" data-testid="recently-viewed-section">
      <div className="flex items-end justify-between mb-4 md:mb-5">
        <div>
          <span className="text-[9px] uppercase tracking-[0.3em] text-[#666] font-body font-bold">Continue Shopping</span>
          <h2 className="text-xl md:text-3xl font-heading font-bold tracking-tight mt-0.5 leading-none">Recently Viewed</h2>
        </div>
        <Link to="/shop" className="group flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold text-[#666] hover:text-[#C9A84C] transition-colors flex-shrink-0">
          View All <ArrowRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 md:gap-x-5 gap-y-5 md:gap-y-6" data-testid="recently-viewed-grid">
        {items.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};
